// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		showLimitList: '24,36,48',
		collapseOnMobileByDefault: true,
		numberFilterTree: 2,
		paginationType: bcSfFilterConfig.custom.pagination == 'infinite_scroll' ? 'infinite' : 
						(bcSfFilterConfig.custom.pagination == 'click_to_load' ? 'load_more' : 'default'),
	},
};

// Declare Templates
var bcSfFilterTemplate = {
	// Grid Template
	'productGridItemHtml': '<li class="{{customClass}}" data-product-item tabindex="1">' +
								'{{itemJson}}' +
								'<article id="{{itemHandle}}" class="productitem" data-product-item-content>' +
									'<a class="productitem--image-link" href="{{itemUrl}}" data-product-page-link>' +
										'<figure class="productitem--image" data-product-item-image>' +
											'{{itemImages}}' +
											'{{itemLabels}}' +
										'</figure>' +
									'</a>' +
									'<div class="productitem--info">' +
										'{{itemSwatchesAlways}}' +
										'{{emphasizePrice}}'  +
										'{{itemVendor}}' +
										'<h2 class="productitem--title">' +
											'<a href="{{itemUrl}}" tabindex="1" data-product-page-link>' +
												'{{itemTitle}}' +
											'</a>' +
										'</h2>' +
										'{{noEmphasizePrice}}'  +
										'{{itemReviews}}' +
										'{{itemSwatchesOnHover}}' +
										'{{itemDescription}}' +
									'</div>' +
									'<div class="productitem--actions" data-product-actions>'+
										'<div class="productitem--listview-price">{{itemPrice}}</div>' +
										'<div class="productitem--listview-badge">{{itemLabels}}</div>' +
										'{{itemActions}}' +
									'</div>' +
								'</article>' +
								'{{itemQuickShopSettings}}' +
							'</li>',

  // Pagination Template
  'previousActiveHtml': '<li class="pagination--previous"><a class="bc-pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' + bcSfFilterConfig.label.prev + '</a></li>',
  'previousDisabledHtml': '',
  'nextActiveHtml': '<li class="pagination--next"><a class="bc-pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
  'nextDisabledHtml': '',
  'pageItemHtml': '<li><a class="bc-pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
  'paginateHtml': '<div class="bc-pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

  // Sorting Template
  'sortingHtml':  '<label class="utils-sortby-title" for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label>' +
				  '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
					  '<select id="bc-sf-filter-top-sorting-select" class="form-field form-field-select">{{sortingItems}}</select>' +
					  '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg>' +
				  '</div>',

  // Show limit Template
  'showLimitHtml': '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + '</span></li>{{showLimitItems}}',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add custom class
	var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
	if (onSale) customClass += ' productitem--sale';
	if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
	itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

	var itemImages = '';
	if (images.length > 0) {
		if (images.length > 1 && bcSfFilterConfig.custom.product_grid_show_second_image) {
			itemImages += buildImage(images[1], '100x', 'productitem--image-alternate');
		}
		itemImages += buildImage(images[0], '100x', 'productitem--image-primary');
	} else {
		itemImages += '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">';
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

	// Add Thumbnail
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '384x') : bcSfFilterConfig.general.no_image_url;
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

	// Add Label
	var itemLabelsHtml = '';
	if (soldOut) {
		itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out + '</span>';
	} else {
		if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
			var savePrice = data.compare_at_price_min - data.price_min;
			var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
			var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
			var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
			itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
			switch (bcSfFilterConfig.custom.product_sales_badge_style) {
				case 'percentile':
					itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml);
					break;
				case 'money':
					itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice));
					break;
				default:
					itemLabelsHtml += bcSfFilterConfig.label.sale;
					break;
			}
			itemLabelsHtml += '</span>';
		}
	}
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

	// Add Price
	var priceHtml = '';
	var classVaries = priceVaries ? 'price--varies' : '';
	var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
	priceHtml += '<div class="productitem--price ' + classVaries + '">';
	priceHtml += '<div class="price--compare-at ' + visibleClass + '" data-price-compare-at>';
	var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
	if (priceVaries && onSale) {
		priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, comparePrice);
	} else {
		if (onSale) {
			priceHtml += comparePrice;
		} else {
			if (bcSfFilterConfig.custom.emphasize_price) {
				priceHtml += '<span class="price--spacer"></span>';
			} else {
				priceHtml += '<span class="money"></span>';
			}
		}
	}
	priceHtml += '</div>';
	priceHtml += '<div class="price--main" data-price>';
	var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
	if (priceVaries) {
		priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, price);
	} else {
		priceHtml += price;
	}
	priceHtml += '</div>';
	priceHtml += '</div>';
	// Add emphasize price
	var emphasizePriceHtml = '';
	var noEmphasizePriceHtml = '';
	if (bcSfFilterConfig.custom.emphasize_price) {
		emphasizePriceHtml += priceHtml;
	} else {
		noEmphasizePriceHtml += priceHtml;
	}
	itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
	itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, priceHtml);

	// Add vendor
	var itemVendorHtml = '';
	if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
		itemVendorHtml += '<h3 class="productitem--vendor">' + data.vendor + '</h3>';
	}
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add review rating
	var itemReviewsHtml = '';
	if (bcSfFilterConfig.custom.product_ratings_reviews) {
		itemReviewsHtml += '<div class="productitem--ratings"><span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span></div>';
	}
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add swatches
	var itemSwatchesHtml = buildSwatch(data);
	if (bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover'){
		itemHtml = itemHtml.replace(/{{itemSwatchesAlways}}/g, '');
		itemHtml = itemHtml.replace(/{{itemSwatchesOnHover}}/g, itemSwatchesHtml);
	} else {
		itemHtml = itemHtml.replace(/{{itemSwatchesAlways}}/g, itemSwatchesHtml);
		itemHtml = itemHtml.replace(/{{itemSwatchesOnHover}}/g, '');
	}   

	// Add description
	var itemDescriptionHtml = '';
	if (data.body_html){
		var description = jQ('<div></div>').html(data.body_html).text(); // Strips html tags
		itemDescriptionHtml += '<div class="productitem--description">';
		itemDescriptionHtml += '<p>' + (description.length > 150 ? description.substring(0, 150) : description) + '</p>';
		if (description.length > 150){
			itemDescriptionHtml += '<a href="{{itemUrl}}" class="productitem--link" data-product-page-link>' + bcSfFilterConfig.label.view_details + '</a>'
		}
		itemDescriptionHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

	// Add data json
	var self = this;
	var itemJson = {
		"id": data.id,
		"title": data.title,
		"handle": data.handle,
		"vendor": data.vendor,
		"variants": data.variants,
		"url": self.buildProductItemUrl(data),
		"options_with_values": data.options_with_values,
		"images": data.images,
		"available": data.available,
		"price_min": data.price_min,
		"price_max": data.price_max,
		"compare_at_price_min": data.compare_at_price_min,
		"compare_at_price_max": data.compare_at_price_max
	};
	itemHtml = itemHtml.replace(/{{itemJson}}/g, '<script type="application/json" data-product-data>' + JSON.stringify(itemJson) + '</script>');

	// Add quickBtn
	var itemActionsHtml = buildActions(data, firstVariant);
	itemHtml = itemHtml.replace(/{{itemActions}}/g, itemActionsHtml);

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	var itemQuickShopSettings = '';
  	if (bcSfFilterConfig.custom.enable_quick_buy) {
	  	itemQuickShopSettings += '<script type="application/json" data-quick-buy-settings>';
	  	itemQuickShopSettings += '{';
		itemQuickShopSettings += '"cart_redirection": ' + bcSfFilterConfig.custom.quickshop_product_cart_redirect + ','
		itemQuickShopSettings += '"money_format": "' + bcSfFilterConfig.custom.money_format + '"'
		itemQuickShopSettings += '}'
	  	itemQuickShopSettings += '</script>';
	}
  	itemHtml = itemHtml.replace(/{{itemQuickShopSettings}}/g, itemQuickShopSettings);

	return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
	return this.buildProductGridItem(data);
};

function buildActions(data, firstVariant){
	var actionsHtml = '';
	var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
	if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
		var quick_look_text = bcSfFilterConfig.label.quick_look_text;
		var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
		var quick_look_classes = 'productitem--action-trigger productitem--action-qs button-secondary';
		var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
		if (has_variants) {
			quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
		}
		if (!data.available) {
			quick_buy_text = bcSfFilterConfig.label.sold_out;
			quick_buy_classes = quick_buy_classes + ' disabled';
		}
		//actionsHtml += '<div class="productitem--actions" data-product-actions>';

		if (bcSfFilterConfig.custom.enable_quick_buy) {
			if (!has_variants) {
				var temp = ' data-quick-buy ';
			} else {
				var temp = '  data-quickshop-trigger="slim" ';
			}
			actionsHtml += '<div class="productitem--action">' +
								'<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
								temp + 'data-variant-id="' + data.variants[0].id + '"';
			if (!data.available) {
				actionsHtml += ' disabled';
			}
			actionsHtml += '>';
			actionsHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
			actionsHtml += '<span class="atc-button--icon">';
			actionsHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';
			actionsHtml += '</span>';
			actionsHtml += '</button>';
			actionsHtml += '</div>';
		}

		if (bcSfFilterConfig.custom.enable_quick_look) {
			actionsHtml += '<div class="productitem--action">' +
								'<button class="'+ quick_look_classes +'"  data-quickshop-trigger="full" data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
								'</button>' +
							'</div>';
		}

		//actionsHtml += '</div>';
	}
	return actionsHtml;
}

function buildImage(imageInfo, size, className) {
	if (!imageInfo) {
		imageInfo = {
			src: bcSfFilterConfig.general.no_image_url,
			width: 480,
			height: 480,
			aspect_ratio: 1
		}
	}

	var html = '<img ' +
		'src="' + bcsffilter.optimizeImage(imageInfo.src, size) + '" ' +
		'class="' + className + '" ' +
		'alt="{{itemTitle}}" ' +
		'data-rimg="lazy" ' +
		'data-rimg-scale="1" ' +
		'data-rimg-template="' + bcsffilter.optimizeImage(imageInfo.src, '{size}') + '" ' +
		'data-rimg-max="' + imageInfo.width + 'x' + imageInfo.height + '" ' +
		'data-rimg-crop ' +
		'srcset="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\''+ imageInfo.width +'\'%20height=\''+ imageInfo.height +'\'></svg>">';

	html += '<div data-rimg-canvas></div>';
	return html;
}

function buildSwatch(data){
	var html = '';
    var swatches = [];
    var swatchValues = [];
    var swatchOptionIndex = 1;
    if (bcSfFilterConfig.custom.swatches_enable && bcSfFilterConfig.custom.swatches_swatch_trigger && !bcSfFilterConfig.custom.swatches_product_page_only){
        var customColors = bcSfFilterConfig.custom.swatches_custom_colors.split('\n');
        data.variants.forEach(function(variant){
            var swatchValue = '';
            variant.options = variant.merged_options; // Use for theme function
            variant.merged_options.forEach(function(merged_option, index){
                var key = merged_option.split(':')[0].trim();
                var value = merged_option.split(':')[1].trim();
                if (key.toLowerCase() == bcSfFilterConfig.custom.swatches_swatch_trigger.toLowerCase() && swatchValues.indexOf(value.toLowerCase()) == -1){               
                    swatchValue = value;
                    swatchValues.push(value.toLowerCase());
                    swatchOptionIndex = index + 1;
                }
            })
            if (swatchValue){
                var swatch ='<label>' +
                                '<input class="productitem--swatches-input" type="radio" name="swatch" value="{{swatchValue}}">' +
                                '<div class="productitem--swatches-swatch-wrapper" data-swatch-tooltip="{{swatchValue}}" data-swatch>' +
                                    '<div class="productitem--swatches-swatch">' +
                                        '<div class="productitem--swatches-swatch-inner" '+
                                        'style="background-color:{{backgroundColor}}; background-color:{{customColor}}; background-image:url({{backgroundImage}}); background-size:cover"></div>' +
                                    '</div>' +
                                '</div>' +
                            '</label>';
                var customColor = '';
                customColors.forEach(function(color){
                    if (color.split(':').length == 2){
                        var customColorName = color.split(':')[0].trim().toLowerCase();
                        var customColorValue = color.split(':')[1].trim().toLowerCase();
                        if (customColorName == swatchValue.toLowerCase()){
                            customColor = customColorValue;
                        }
                    }
                })
                
                var slugifyValue = bcsffilter.slugify(swatchValue);
                var backgroundColor = slugifyValue.split('-').pop();
                var backgroundImage = bcSfFilterMainConfig.general.file_url.split('?')[0] + slugifyValue + '.png';

                swatch = swatch.replace(/{{swatchValue}}/g, swatchValue);
                swatch = swatch.replace(/{{backgroundColor}}/g, backgroundColor);
                swatch = swatch.replace(/{{backgroundImage}}/g, backgroundImage);
                swatch = swatch.replace(/{{customColor}}/g, customColor);
                swatches.push(swatch);
            }
        })
        
        if (swatchValues.length > 0){           
			var html = '';
			if (bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover'){
				var swatchesCountLabel = swatchValues.length > 1 ? bcSfFilterConfig.label.swatches_count_other : bcSfFilterConfig.label.swatches_count_one;
				swatchesCountLabel = swatchesCountLabel.replace(/{{ count }}/g, swatchValues.length);
				html += '<div class="productitem--swatches-summary">' + swatchesCountLabel + '</div>';
			}
			html +=  '<div class="productitem--swatches productitem--swatches-show-'+ bcSfFilterConfig.custom.swatches_product_card_hover +'" data-swatches>' +
                        '<script type="application/json" data-swatch-data>' +
                          '{' +
                            '"hash": "{{itemDataSha256}}",' +
							'"swatchOptionKey": "{{swatchOptionKey}}",' +
							'"swatchesProductCardHover": "'+ bcSfFilterConfig.custom.swatches_product_card_hover + '"' +
                          '}' +
                        '</script>' +
                        '<form class="productitem--swatches-container" data-swatches-container>' +
                            swatches.join(' ') +
						'</form>' +
						(
						bcSfFilterConfig.custom.swatches_product_card_hover == 'on-hover' ?
						'' :
                        '<div class="productitem--swatches-count-wrapper" data-swatch-count-wrapper>' +
                            '<div class="productitem--swatches-count" data-swatch-count>+</div>' +
						'</div>'
						) +
                    '</div>';
            
            html = html.replace(/{{swatchOptionKey}}/g, 'option' + swatchOptionIndex);
            html = html.replace(/{{variantsJson}}/g, JSON.stringify(data.variants));
        }
    }
    
    return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
	if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ(this.selector.topShowLimit).html('');

		var numberList = this.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k = 0; k < arr.length; k++) {
				if (arr[k] == this.queryParams.limit) {
					showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] + '">' + arr[k] + '</a></li>';
				} else {
					showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] + '">' + arr[k] + '</a></li>';
				}
			}
			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			jQ(this.selector.topShowLimit).html(html);
		}
	}
};

BCSfFilter.prototype.buildShowLimitEvent = function () {
	var _this = this;
	jQ(this.selector.topShowLimit + ' li a').click(function (e) {
		onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
	})
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
	if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
		var colInfo = colData.collection;
		var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
		var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> ';
		breadcrumbHtml += delimiter;
		breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
		jQ('.breadcrumbs-container').html(breadcrumbHtml);
	}
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
	// Fix heigh issue on list view
	jQ('#bc-sf-filter-products li[data-product-item]').css('height', 'initial').css('min-height', 'initial').css('max-height', 'initial');

	// Bind events
	var _this = this;
	jQ(_this.selector.topDisplayType + ' button').off('click');
	jQ(_this.selector.topDisplayType + ' button').on('click', function (e) {
		var newValue = jQ(this).attr('data-display-type');
		sessionStorage.setItem('data-display-type', newValue);
		jQ(this).parent().children('button').removeClass('active');
		jQ(this).addClass('active');
		if (newValue == 'list-view') {
			jQ('.productgrid--outer').removeClass('productgrid-gridview');
			jQ('.productgrid--outer').addClass('productgrid-listview');
			
			// Fix heigh issue on list view
			jQ('#bc-sf-filter-products li[data-product-item]').each(function(){
				var height = jQ(this).height() + 'px';
				jQ(this).css('height', height).css('min-height', height).css('max-height', height);
			});
		} else {
			jQ('.productgrid--outer').removeClass('productgrid-listview');
			jQ('.productgrid--outer').addClass('productgrid-gridview');

			// Fix heigh issue on list view
			jQ('#bc-sf-filter-products li[data-product-item]').css('height', 'initial').css('min-height', 'initial').css('max-height', 'initial');
		}
	});
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	var self = this;
	var total_products = data.length;
	var count = 0;
	if (bcSfFilterConfig.custom.enable_quick_buy || bcSfFilterConfig.custom.enable_quick_look) {
		jQ(self.getSelector('products')).find(".productgrid--item").each(function (e) {
			var _this = this;
			var url = jQ(this).find(".productitem--image-link").eq(0).attr("href");
			jQ.ajax({
				type: "GET",
				url: url + '?view=bc-sf-quickview',
				success: function (data) {
					if (jQ(_this).find('.productitem-quickshop').length == 0){
						jQ(_this).append(data);
						jQ(_this).find('.productitem--action').css('display', 'block');
						count++;
						if (count == total_products) {
							buildTheme();
						}
					}
				}
			});
		});
	} else {
		buildTheme();
	}
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	// Build search page breadcrumbs
	if (this.isSearchPage()) {
		var content = '';
		var searchTerm = this.escape(this.getSearchTerm());
		if (searchTerm != null) {
			content = bcSfFilterConfig.label.search_breadcrumbs_count_other;
			if (data.total_product == 1) {
				content = bcSfFilterConfig.label.search_breadcrumbs_count_one;
			} else if (data.total_product == 0) {
				content = bcSfFilterConfig.label.search_breadcrumbs_count_zero;
			}
			content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
			content = content.replace(/&lt;strong&gt;/g, '<strong>').replace(/&lt;\/strong&gt;/g, '</strong>');
		}
		jQ('.breadcrumbs-container span:last-child').html(content);
		jQ('.breadcrumbs-container span').css('display', 'inline-block');
	}
};

function buildTheme(){
	// In superstore.js or superstore.min.js:
    // - Add "var bcSections; var bcStaticCollection;" to the begining
    // - Find "var sections = new Sections();", replace like below:

    // var sections = new Sections();
	// bcSections = sections;
	// bcStaticCollection = StaticCollection_StaticCollection;
	// sections.register....
	
	// Clear recently viewed
	// if (jQ('[data-recently-viewed-container]').length > 0) {
	// 	jQ('[data-recently-viewed-container]').html('');
	// }

	// Reinit theme
	if (window.bcSections && window.bcStaticCollection){
		bcSections.unbind('static-collection');
		bcSections.register('static-collection', function (section) {
			return new bcStaticCollection(section);
		});
	}
	if (window.bcImage){
		bcImage.init('[data-rimg="lazy"]', {
			round: 1
		});
	}
			
	var display = sessionStorage.getItem('data-display-type');
	if (display == 'list-view'){
		jQ('[data-display-type="list-view"]').click();
	} else {
		jQ('[data-display-type="grid-view"]').click();
	}
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
